/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import uiRouter from 'angular-ui-router';
import thingsboardGrid from '../components/grid.directive';
import thingsboardApiTenant from '../api/tenant.service';
import thingsboardContact from '../components/contact.directive';
import thingsboardContactShort from '../components/contact-short.filter';

import TenantRoutes from './tenant.routes';
import TenantController from './tenant.controller';
import TenantDirective from './tenant.directive';

export default angular.module('thingsboard.tenant', [
    uiRouter,
    thingsboardGrid,
    thingsboardApiTenant,
    thingsboardContact,
    thingsboardContactShort
])
    .config(TenantRoutes)
    .controller('TenantController', TenantController)
    .directive('tbTenant', TenantDirective)
    .name;



// WEBPACK FOOTER //
// ./src/app/tenant/index.js